import { createClient } from '@supabase/supabase-js'

// Get Supabase configuration from environment variables
// This allows different URLs for dev/prod environments
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'http://localhost:8000'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

// Validate the key format (no logging for security)
const validateApiKey = (key) => {
  if (!key || key.length < 150) return false;
  const parts = key.split('.');
  if (parts.length !== 3) return false;
  try {
    const payload = JSON.parse(atob(parts[1]));
    if (payload.role !== 'anon') return false;
    if (payload.iss !== 'supabase') return false;
    if (payload.exp && payload.exp < Date.now() / 1000) return false;
    return true;
  } catch {
    return false;
  }
};

const isKeyValid = validateApiKey(supabaseAnonKey);
if (!isKeyValid) {
  // Key invalid; client will still be created but may fail at runtime
}

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Export individual functions for easier use
export const {
  auth,
  database,
  storage,
  realtime
} = supabase